






































import DeleteProjectChangeDialog from "../Dialogs/DeleteProjectChangeDialog.vue";
import { Ref, ref } from "vue-demi";
import BaseTable from "./BaseTable.vue";
import {
  ProjectChangesQuery,
  useProjectChangesQuery,
} from "@/generated/backend";
import { useResult } from "@vue/apollo-composable";
import CreateProjectChangeDialog from "../Dialogs/Dele.vue";
import router from "@/router";

export default {
  components: {
    BaseTable,
    DeleteProjectChangeDialog,
  },
  props: {
    project: {
      type: Object,
    },
  },
  setup(props) {
    const table = ref(null);

    return {
      table,
      headers: [
        {
          text: "Dátum úpravy",
          align: "start",
          value: "UpdatedAt",
          searchable: false,
        },
        {
          text: "Užívateľ",
          value: "modifiedBy",
          sortable: false,
          searchable: true,
          searchFunc: (s) => ({
            modifiedBy: {
              Username: {
                iLike: `%${s}%`,
              },
            },
          }),
        },
        { text: "Stav", value: "State", searchable: true },
        {
          text: "Popis",
          value: "Description",
          searchable: true,
          sortable: true,
        },
        { text: "", value: "actions", sortable: false },
      ],

      useProjectChangesQuery,
      itemsGetter: (result: Ref<ProjectChangesQuery>) =>
        useResult(result, [], (d) => d.projectChanges.nodes),
      totalCountGetter: (result: Ref<ProjectChangesQuery>) =>
        useResult(result, 0, (d) => d.projectChanges.totalCount),
      reloadTable: () => (table as any).value.reload(),
      onRowClick: (item) =>
        router.push({ name: "ProjectChangeDetail", params: { id: item.Id } }),
    };
  },
};
